import BaseModel from '../../base';

import { rHandler } from '@/plugins/RHandler';
import { DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import { apiService } from '@/services/APIService';

import constants, { LOGIN_TYPE, MOBILE_ALERT_TYPE } from './constants';
import glossary, { MOBILE_ALERT_DATA } from './glossary';
import { addDays } from 'date-fns';
import { defaultFormat } from '@/plugins/date-print';

export default class UserLoginInfo extends BaseModel {
  constructor(item = {}, url = 'user/login-info') {
    super(item, url);
    this.user_id = item.user_id;
    this.login_type = item.login_type || LOGIN_TYPE.web;
    this.app_login_confirm = item.app_login_confirm ?? false;

    this.date_display_at = item.date_display_at || null;
    this.last_login_at = item.last_login_at || null;

    this.created_at = item.created_at;
    this.updated_at = item.updated_at;
  }

  get mobileAlertType() {
    if (!this.date_display_at) {
      return MOBILE_ALERT_TYPE.first;
    }
    return MOBILE_ALERT_TYPE.second;
  }

  get showMobileAlert() {
    const { date_display_at, app_login_confirm } = this;
    if (app_login_confirm) return false;
    if (!date_display_at) return true;
    return new Date().getTime() >= new Date(date_display_at).getTime();
  }

  get api() {
    const { url, mobileAlertType } = this;
    const loginInfo = this;
    return {
      get dateDisplay() {
        const path = `${url}/date-display-at`;
        return {
          continue({ obs } = DEFAULT_PARAMS) {
            const data = {
              date_display_at: defaultFormat(addDays(new Date(), MOBILE_ALERT_DATA[mobileAlertType].days)),
            };
            return rHandler(
              apiService.post(`${path}`, data),
              (response) => {
                loginInfo.date_display_at = response?.data?.data?.date_display_at || loginInfo.date_display_at;
                return response;
              },
              (error) => ({ error }),
              obs,
            );
          },
        };
      },
    };
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
